/**
 * Predefined (static) section and fields for the Employee Master (manual add employee) form.
 * Shown in the Employee Master Form Builder as read-only rows (with active +
 * mandatory/optional toggles) and rendered with their bespoke widgets in the live
 * AddEmployeeMaster form. Admin-built custom field values are stored in customFields.
 *
 * Field names must match the form field `name` props in AddEmployeeMaster.js and the
 * DEFAULT_EM_REQUIRED map in server/controller/employees.js.
 */

export const EM_PREDEFINED_SECTION_KEY = "predefined_employee_info";
export const EM_PREDEFINED_SECTION_NAME = "Employee Information";

export const EM_PREDEFINED_SECTION = {
  _id: "predefined_section",
  sectionName: EM_PREDEFINED_SECTION_NAME,
  sectionKey: EM_PREDEFINED_SECTION_KEY,
  isDefault: true,
  isPredefined: true,
  order: -1,
};

export const EM_PREDEFINED_FIELDS = [
  { fieldName: "first_name", fieldLabel: "First Name", fieldType: "text", required: true, order: 0, locked: true },
  { fieldName: "middleName", fieldLabel: "Middle Name", fieldType: "text", required: false, order: 1 },
  { fieldName: "last_name", fieldLabel: "Last Name", fieldType: "text", required: true, order: 2, locked: true },
  {
    fieldName: "gender",
    fieldLabel: "Gender",
    fieldType: "select",
    required: true,
    options: [
      { key: "Male", value: "Male" },
      { key: "Female", value: "Female" },
      { key: "Transgender", value: "Transgender" },
    ],
    order: 3,
  },
  { fieldName: "date_of_birth", fieldLabel: "Date Of Birth", fieldType: "date", required: true, order: 4 },
  { fieldName: "fathername", fieldLabel: "Father's Name", fieldType: "text", required: false, order: 5 },
  { fieldName: "mothername", fieldLabel: "Mother's Name", fieldType: "text", required: false, order: 6 },
  {
    fieldName: "marital_status",
    fieldLabel: "Marital Status",
    fieldType: "select",
    required: false,
    options: [
      { key: "Married", value: "Married" },
      { key: "Un-Married", value: "Un-Married" },
    ],
    order: 7,
  },
  { fieldName: "permail", fieldLabel: "Personal Mail ID", fieldType: "email", required: true, order: 8 },
  { fieldName: "pno", fieldLabel: "Personal Phone No", fieldType: "phone", required: true, order: 9 },
  { fieldName: "address", fieldLabel: "Address", fieldType: "textarea", required: false, order: 10 },
  { fieldName: "qualifications", fieldLabel: "Qualifications", fieldType: "text", required: false, order: 11 },
  { fieldName: "hobbies", fieldLabel: "Hobbies", fieldType: "text", required: false, order: 12 },
  { fieldName: "branch", fieldLabel: "Branch", fieldType: "select", required: true, order: 13 },
  { fieldName: "department_id", fieldLabel: "Department", fieldType: "select", required: true, order: 14, locked: true },
  { fieldName: "designation_id", fieldLabel: "Designation", fieldType: "select", required: true, order: 15, locked: true },
  { fieldName: "salary_grade", fieldLabel: "Salary Grade", fieldType: "select", required: false, order: 16 },
  { fieldName: "employee_type", fieldLabel: "Employee Type", fieldType: "select", required: true, order: 17, locked: true },
  { fieldName: "experience_grade", fieldLabel: "Experience Grade", fieldType: "select", required: false, order: 18 },
  { fieldName: "reporting_manager", fieldLabel: "Reporting Manager", fieldType: "select", required: true, order: 19 },
  { fieldName: "assistant_reporting_manager", fieldLabel: "Asst. Reporting Manager", fieldType: "select", required: false, order: 20 },
  { fieldName: "buddy", fieldLabel: "Buddy", fieldType: "select", required: false, order: 21 },
  { fieldName: "email", fieldLabel: "Email", fieldType: "email", required: true, order: 22, locked: true },
  { fieldName: "biomax_employee_code", fieldLabel: "Punching Employee Code", fieldType: "text", required: false, order: 23 },
  { fieldName: "biomax_employee_email", fieldLabel: "Biomax Employee Email", fieldType: "email", required: false, order: 24 },
  { fieldName: "date_of_joining", fieldLabel: "Date of Joining", fieldType: "date", required: true, order: 25, locked: true },
  { fieldName: "experience", fieldLabel: "Experience", fieldType: "number", required: true, order: 26 },
  { fieldName: "referred_by", fieldLabel: "Referred By", fieldType: "text", required: false, order: 27 },
  { fieldName: "employee_code", fieldLabel: "Employee Code", fieldType: "text", required: false, order: 28 },
  { fieldName: "country", fieldLabel: "Country", fieldType: "select", required: true, order: 29 },
  { fieldName: "state", fieldLabel: "State", fieldType: "select", required: true, order: 30 },
  { fieldName: "district", fieldLabel: "District", fieldType: "text", required: false, order: 31 },
  { fieldName: "city", fieldLabel: "City/Village", fieldType: "select", required: true, order: 32 },
  { fieldName: "pin_code", fieldLabel: "Pin Code", fieldType: "text", required: true, order: 33 },
  {
    fieldName: "appraisal_date",
    fieldLabel: "Appraisal",
    fieldType: "select",
    required: false,
    options: [
      { key: "January", value: "January" },
      { key: "April", value: "April" },
      { key: "July", value: "July" },
      { key: "October", value: "October" },
    ],
    order: 34,
  },
];
